<script>
// import Layout from '../layouts/main';
// import PageHeader from '@/components/page-header';
import axios from "axios";
import moment from "moment";

// import "datatables.net-bs5";
// import "jszip";
// import "pdfmake";
// import "datatables.net-buttons-bs5";
// import "datatables.net-buttons/js/buttons.colVis";
// import "datatables.net-buttons/js/buttons.flash";
// import "datatables.net-buttons/js/buttons.html5";
// import "datatables.net-buttons/js/buttons.print";

// import $ from "jquery";

export default {
  page: {
    title: "Reports",
    meta: [
      {
        name: "Reports",
      },
    ],
  },
  props: ["slug"],
  //   components: { Layout, PageHeader },
  mounted() {
    this.reportsToggler();
    this.generateReport();
    this.getLocations();
  },
  data() {
    return {
      title: "",
      items: [
        {
          text: "",
          href: "/",
        },
      ],
      preservePage: 1,
      pageLimit: 70,
      isLoadingDownload: false,
      noReportSelected: true,
      isMaster: false,
      isMasterV2: false,
      isRep1: false,
      isRep2: false,
      isRep3: false,
      isRep4: false,
      isRep5: false,
      isRep6: false,
      isRep7: false,
      isRep8: false,
      isMentorHours: false,
      isMentorRolesStart: false,
      total_hours: 0,
      total_minutes: 0,
      isWeeklyBirthday: false,
      isLoading: false,
      noRecord: false,
      start_date: null,
      end_date: null,
      buildings: null,
      building: null,
      application_status: null,
      locations: null,
      location: null,
      reportData: [],
      applicationStatuses: [
        { value: "Review Application", text: "Review Application" },
        {
          value: "Confirm Application Status",
          text: "Confirm Application Status",
        },
        {
          value: "Send DHS & Orientation email",
          text: "Send DHS & Orientation email",
        },
        {
          value: "Send Application Response and DHS email",
          text: "Send Application Response and DHS email",
        },
        { value: "Send DHS email", text: "Send DHS email" },
        {
          value: "State ID, Authorization Form, Date of Orientation Received",
          text: "State ID, Authorization Form, Date of Orientation Received",
        },
        {
          value: "Send Fingerprinting instructions email",
          text: "Send Fingerprinting instructions email",
        },
        {
          value: "Start DHS Background Check",
          text: "Start DHS Background Check",
        },
        {
          value: "Start DHS Background Check (NetStudy 2.0)",
          text: "Start DHS Background Check (NetStudy 2.0)",
        },
        {
          value: "Check Fingerprinting Status",
          text: "Check Fingerprinting Status",
        },
        {
          value: "Confirm Fingerprinting with Applicant",
          text: "Confirm Fingerprinting with Applicant",
        },
        { value: "Confirm DHS Status", text: "Confirm DHS Status" },
        {
          value: "Upload DHS determination letter to R Drive",
          text: "Upload DHS determination letter to R Drive",
        },
        { value: "Send Calendar Invite", text: "Send Calendar Invite" },
        {
          value: "Screening Meeting (Phone Call)",
          text: "Screening Meeting (Phone Call)",
        },
        {
          value: "Schedule Orientation / Intro Meeting",
          text: "Schedule Orientation / Intro Meeting",
        },
        {
          value: "Send Orientation confirmation email",
          text: "Send Orientation confirmation email",
        },
        { value: "Orientation Completed", text: "Orientation Completed" },
        { value: "Application Approved", text: "Application Approved" },
        { value: "Assign Applicant", text: "Assign Applicant" },
        { value: "Send Assignment Email", text: "Send Assignment Email" },
        { value: "Feedback on Assignment", text: "Feedback on Assignment" },
        {
          value: "Schedule first Assignment",
          text: "Schedule first Assignment",
        },
        {
          value: "Confirm Onboarding Complete",
          text: "Confirm Onboarding Complete",
        },
        {
          value: "Confirm Assignment Date/Role",
          text: "Confirm Assignment Date/Role",
        },
        {
          value: "Orientation / Intro Meeting Complete",
          text: "Orientation / Intro Meeting Complete",
        },
        {
          value: "Start Intellicorps Background Check",
          text: "Start Intellicorps Background Check",
        },
        {
          value: "Send Application Received Email",
          text: "Send Application Received Email",
        },
        {
          value: "Confirm Intellicorps Background Status",
          text: "Confirm Intellicorps Background Status",
        },
        { value: "Remove SS and DL", text: "Remove SS and DL" },
        {
          value: "Review Character References",
          text: "Review Character References",
        },
        {
          value: "Character Reference Confirmed",
          text: "Character Reference Confirmed",
        },
        { value: "Document Case Details", text: "Document Case Details" },
        {
          value: "Email Applicant Background Information to CCM",
          text: "Email Applicant Background Information to CCM",
        },
        {
          value: "Send assignment email to mentor/CCM",
          text: "Send assignment email to mentor/CCM",
        },
        {
          value: "Send Meeting Invite Email to Applicant",
          text: "Send Meeting Invite Email to Applicant",
        },
        { value: "Confirm Meeting Date", text: "Confirm Meeting Date" },
        {
          value: "Review Application / Waitlist",
          text: "Review Application / Waitlist",
        },
        {
          value: "Screening Meeting Complete",
          text: "Screening Meeting Complete",
        },
        {
          value: "Introduce Applicant to Client",
          text: "Introduce Applicant to Client",
        },
        {
          value: "Confirm (ROI) Release of Information Signature",
          text: "Confirm (ROI) Release of Information Signature",
        },
        {
          value: "Document Introduction Date/Client",
          text: "Document Introduction Date/Client",
        },
        {
          value: "Follow-up on Check Fingerprinting Status",
          text: "Follow-up on Check Fingerprinting Status",
        },
        {
          value: "Screening Meeting (Phone Call)",
          text: "Screening Meeting (Phone Call)",
        },
      ],
      masterReport: {
        resource_id: "",
        first_name: "",
        last_name: "",
        DOB: "",
        gender: "",
        phone: "",
        mobile: "",
        email: "",
        status: "",
        application_date: "",
        category: "",
        location_name: "",
        location_city: "",
        location_state: "",
      },
    };
  },
  methods: {
    dateFormatter(value) {
      return moment(value).format("MM/DD/YYYY");
    },
    getLocations() {
      axios.get("admin/locations").then((res) => {
        this.locations = res.data.response;
      });
    },
    getBuildings(location_id) {
      let filter = "&location_id=" + location_id;
      axios
        .get("admin/buildings?pagination=false" + filter)
        .then((res) => {
          this.buildings = res.data.response;
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.status == 401) {
              this.logout();
            }
          }
        });
    },
    generateReport(page) {
      this.isLoading = true;
      this.noRecord = false;

      let type = this.slug;
      if (typeof page === "undefined") {
        page = 1;
      }
      this.preservePage = page;
      let filter = "&per_page=" + this.pageLimit;
      if (this.start_date && this.end_date) {
        filter += "&start_date=" + this.start_date;
        filter += "&end_date=" + this.end_date;
      }
      if (this.location) {
        filter += "&location=" + this.location;
      }
      if (this.building) {
        filter += "&building=" + this.building;
      }
      if (this.application_status) {
        filter +=
          "&application_status=" + encodeURIComponent(this.application_status);
      }

      var token = localStorage.getItem("token");
      var config = {
        headers: { Authorization: "Bearer " + token },
      };
      console.log(filter);
      let endpoint = "";
      if (this.isMentorHours == true) {
        endpoint = "admin/mentorHoursReport";
      } else if (this.isMentorRolesStart == true) {
        endpoint = "admin/mentorRoleStartReport";
      } else if (this.isWeeklyBirthday == true) {
        endpoint = "admin/weeklyBirthdayReport";
      } else {
        endpoint = "admin/reports/" + type;
      }
      axios
        .get(endpoint + "?pagination=true&page=" + page + filter, config)
        .then((res) => {
          if (res.status == 200) {
            if (res.data.status == true) {
              console.log(res.data.data);
              this.reportData = res.data.data;
              if (this.isMentorHours == true) {
                this.total_hours = res.data.total_hours;
                this.total_minutes = res.data.total_minutes;
              }
              this.isLoading = false;
              if (!this.reportData.data.length) {
                this.noRecord = true;
                if (page > 1) {
                  this.generateReport(type, page - 1);
                }
              }
            }
          }
        })
        .catch((err) => {
          if (err.response) {
            console.log(err.response.data.error.message);
          }
        });
    },

    reportsToggler() {
      let type = this.slug;

      if (type == "master") {
        this.isMaster = true;
      } else if (type == "rep1") {
        this.isRep1 = true;
      } else if (type == "rep2") {
        this.isRep2 = true;
      } else if (type == "rep3") {
        this.isRep3 = true;
      } else if (type == "rep4") {
        this.isRep4 = true;
      } else if (type == "rep5") {
        this.isRep5 = true;
      } else if (type == "rep6") {
        this.isRep6 = true;
      } else if (type == "masterv2") {
        this.isMasterV2 = true;
      } else if (type == "rep7") {
        this.isRep7 = true;
      } else if (type == "mentorHours") {
        this.isMentorHours = true;
      } else if (type == "MentorRolesStart") {
        this.isMentorRolesStart = true;
      } else if (type == "isWeeklyBirthday") {
        this.isWeeklyBirthday = true;
      }
    },
    downloadReport() {
      let type = this.slug;
      this.isLoadingDownload = true;
      // let usersData = [];
      var token = localStorage.getItem("token");
      var config = {
        headers: { Authorization: "Bearer " + token },
      };
      let filter = "?pegination=true";
      if (this.start_date && this.end_date) {
        filter += "&start_date=" + this.start_date;
        filter += "&end_date=" + this.end_date;
      }
      if (this.location) {
        console.log(this.location);
        filter += "&location=" + this.location;
      }
      if (this.building) {
        filter += "&building=" + this.building;
      }
      if (this.application_status) {
        filter += "&application_status=" + this.application_status;
      }
      let endpoint = "";
      if (this.isMentorHours == true) {
        endpoint = "admin/csvHoursDownload" + filter;
      } else if (this.isMentorRolesStart == true) {
        endpoint = "admin/csvMentorRoleStartDownload";
      } else if (this.isWeeklyBirthday == true) {
        endpoint = "admin/csvWeeklyBirthdayDownload" + filter;
      } else {
        endpoint = "admin/csvdownload/" + type + filter;
      }

      // csvHoursDownload
      axios
        .get(endpoint, config)
        .then((res) => {
          if (res.status == 200) {
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            // const link = document.createElement("a");
            // link.href = url;
            // link.setAttribute("download", `${this.slug}.csv`); // Set the file name
            // document.body.appendChild(link);
            // link.click();
            // this.isLoadingDownload = false;
          }
        })
        .catch((err) => {
          if (err.response) {
            console.log(err.response.data.error.message);
          }
        });
    },
  },
};
</script>

<template>
  <div class="MainContainer">
    <!-- <Layout> -->
    <!-- <PageHeader :title="title" :items="items" /> -->
    <div class="card">
      <div class="card-body">
        <div class="noReportSelected mb-4 mt-4 text-right">
          <button
            type="button"
            class="btn btn-danger me-3"
            @click="downloadReport()"
          >
            Download CSV
          </button>

          <router-link class="btn btn-primary" tag="a" :to="`/reports`">
            Back To Reports
          </router-link>

          <div id="csvlodaer" v-if="isLoadingDownload">
            <h2 class="d-flex align-items-center">
              Your report is being prepared. you will be notified to your email
              once completed. Please check the "Download Reports" tab in the
              Reports section for status updates.
            </h2>
          </div>
        </div>

        <!-- MASTER REPORT -->
        <div class="mb-4 mt-4" v-if="isMaster">
          <h2 class="mb-5 mt-4">Master Report</h2>

          <table id="masterTable" class="table">
            <thead class="table-light">
              <tr>
                <th>Resource ID</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Gender</th>
                <th>Email</th>
                <th>DOB</th>
                <th>Phone</th>
                <th>Mobile</th>
                <th>Location City</th>
                <th>Location Name</th>
                <th>Location State</th>
                <th>Application Date</th>
                <th>Assign To</th>
                <th>Building</th>
                <th>Category</th>
                <th>Department</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="noRecord">
                <td colspan="17" class="p-0">
                  <p class="font-size-16 text-center mt-2 mb-0">
                    Record Not Found!
                  </p>
                </td>
              </tr>

              <tr v-if="isLoading">
                <td colspan="17" class="text-center p-0">
                  <b-spinner
                    class="m-2"
                    variant="primary"
                    role="status"
                  ></b-spinner>
                </td>
              </tr>

              <tr v-else v-for="(data, index) in reportData.data" :key="index">
                <td>{{ data.resource_id }}</td>
                <td>{{ data.first_name }}</td>
                <td>{{ data.last_name }}</td>
                <td>{{ data.gender }}</td>
                <td>{{ data.email }}</td>
                <td>{{ data.DOB }}</td>
                <td>{{ data.phone }}</td>
                <td>{{ data.mobile }}</td>
                <td>{{ data.location_city }}</td>
                <td>{{ data.location_name }}</td>
                <td>{{ data.location_state }}</td>
                <td>{{ data.application_date }}</td>
                <td>{{ data.assign_to }}</td>
                <td>{{ data.building }}</td>
                <td>{{ data.category }}</td>
                <td>{{ data.department }}</td>
                <td>{{ data.status }}</td>
              </tr>
            </tbody>
          </table>
          <pagination
            class="mt-4"
            :data="reportData"
            :limit="10"
            @pagination-change-page="generateReport"
          ></pagination>
        </div>

        <!-- MASTER V2 REPORT -->
        <div class="table-responsive mb-4 mt-4" v-if="isMasterV2">
          <div class="report_header d-flex justify-space-between mb-5">
            <h2 class="mb-5 mt-4">Master-V2 Report</h2>

            <form class="d-flex justify-content-end" action="">
              <div class="col-md-4 mr-2 me-2">
                <label>Application Status</label>
                <b-form-select
                  class="form-select"
                  v-model="application_status"
                  :options="applicationStatuses"
                  value-field="value"
                  text-field="text"
                >
                  <option slot="first" :value="null">-- All Statuses --</option>
                </b-form-select>
              </div>
              <div class="col-md-2 d-grid">
                <label>&nbsp;</label>
                <button
                  type="button"
                  @click="generateReport()"
                  class="btn btn-primary"
                >
                  Filter
                </button>
              </div>
            </form>
          </div>

          <table id="masterv2Table" class="table">
            <thead class="table-light">
              <tr>
                <th>Center</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Phone</th>
                <th>Email</th>
                <th>DOB</th>
                <th>Address 1</th>
                <th>Address 2</th>
                <th>City</th>
                <th>State</th>
                <th>Zip Code</th>
                <th>Category</th>
                <th>Assign To</th>
                <th>Building</th>
                <th>Department</th>
                <th>Status</th>
                <th>Application Date</th>
                <th>DHS Clearance Date</th>
                <th>Orientation Date</th>
                <th>Assigned to Role Date</th>
                <th>Church Name</th>
                <th>Church City</th>
                <th>Church State</th>
                <th>Current Occupation</th>
                <th>Name of Employer</th>
                <th>City/State of Employer</th>
                <th>Hobbies, Interests, Passions</th>
                <th>Foreign Languages</th>
                <th>Opportunities</th>
                <th>Character Reference Name</th>
                <th>Gender</th>
                <th>Constituent ID</th>
                <th>Application Status</th>
                <th>Position Type</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="noRecord">
                <td colspan="34" class="p-0">
                  <p class="font-size-16 text-center mt-2 mb-0">
                    Record Not Found!
                  </p>
                </td>
              </tr>

              <tr v-if="isLoading">
                <td colspan="34" class="text-center p-0">
                  <b-spinner
                    class="m-2"
                    variant="primary"
                    role="status"
                  ></b-spinner>
                </td>
              </tr>

              <tr v-else v-for="(data, index) in reportData.data" :key="index">
                <td>{{ data.center }}</td>
                <td>{{ data.first_name }}</td>
                <td>{{ data.last_name }}</td>
                <td>{{ data.phone }}</td>
                <td>{{ data.email }}</td>
                <td>{{ data.DOB }}</td>
                <td>{{ data.address1 }}</td>
                <td>{{ data.address2 }}</td>
                <td>{{ data.city }}</td>
                <td>{{ data.state }}</td>
                <td>{{ data.zip_code }}</td>
                <td>{{ data.category }}</td>
                <td>{{ data.assign_to }}</td>
                <td>{{ data.building }}</td>
                <td>{{ data.department }}</td>
                <td>{{ data.status }}</td>
                <td>{{ data.application_date }}</td>
                <td>{{ data.dhs_clearance_date }}</td>
                <td>{{ data.orientation_date }}</td>
                <td>{{ data.assign_to_date }}</td>
                <td>{{ data.church_name }}</td>
                <td>{{ data.church_city }}</td>
                <td>{{ data.church_state }}</td>
                <td>{{ data.occupation }}</td>
                <td>{{ data.employer_name }}</td>
                <td>{{ data.employer_city_state }}</td>
                <td>{{ data.hobbies }}</td>
                <td>{{ data.foreign_language }}</td>
                <td>{{ data.opprtunities }}</td>
                <td>{{ data.cr_name }}</td>
                <td>{{ data.gender }}</td>
                <td>{{ data.constituent_id }}</td>
                <td>{{ data.user_current_status }}</td>
                <td>{{ data.position_type }}</td>
              </tr>
            </tbody>
          </table>

          <pagination
            class="mt-4"
            :data="reportData"
            :limit="10"
            @pagination-change-page="generateReport"
          ></pagination>
        </div>

        <!-- REPORT - 1 -->
        <div class="mb-4 mt-4" v-if="isRep1">
          <h2 class="mb-5 mt-4">Volunteer Management Master</h2>

          <table id="rep1Table" class="table">
            <thead class="table-light">
              <tr>
                <th>Location</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Status</th>
                <th>Category</th>
                <th>Role</th>
                <th>Assign Date</th>
                <th>Gender</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="noRecord">
                <td colspan="10" class="p-0">
                  <p class="font-size-16 text-center mt-2 mb-0">
                    Record Not Found!
                  </p>
                </td>
              </tr>

              <tr v-if="isLoading">
                <td colspan="10" class="text-center p-0">
                  <b-spinner
                    class="m-2"
                    variant="primary"
                    role="status"
                  ></b-spinner>
                </td>
              </tr>

              <tr v-else v-for="(data, index) in reportData.data" :key="index">
                <td>{{ data.center }}</td>
                <td>{{ data.first_name }}</td>
                <td>{{ data.last_name }}</td>
                <td>{{ data.email }}</td>
                <td>{{ data.phone }}</td>
                <td>{{ data.status }}</td>
                <td>{{ data.category }}</td>
                <td>{{ data.assign_to }}</td>
                <td>{{ data.assign_to_date }}</td>
                <td>{{ data.gender }}</td>
              </tr>
            </tbody>
          </table>
          <pagination
            class="mt-4"
            :data="reportData"
            :limit="10"
            @pagination-change-page="generateReport"
          ></pagination>
        </div>

        <!-- REPORT - 2 -->
        <div class="mb-4 mt-4" v-if="isRep2">
          <h2 class="mb-5 mt-4">Report - 2</h2>

          <table id="rep2Table" class="table">
            <thead class="table-light">
              <tr>
                <th>Resource ID</th>
                <th>Center</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Status</th>
                <th>Building</th>
                <th>Assign To</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="noRecord">
                <td colspan="7" class="p-0">
                  <p class="font-size-16 text-center mt-2 mb-0">
                    Record Not Found!
                  </p>
                </td>
              </tr>

              <tr v-if="isLoading">
                <td colspan="7" class="text-center p-0">
                  <b-spinner
                    class="m-2"
                    variant="primary"
                    role="status"
                  ></b-spinner>
                </td>
              </tr>

              <tr v-else v-for="(data, index) in reportData.data" :key="index">
                <td>{{ data.resource_id }}</td>
                <td>{{ data.center }}</td>
                <td>{{ data.first_name }}</td>
                <td>{{ data.last_name }}</td>
                <td>{{ data.status }}</td>
                <td>{{ data.building }}</td>
                <td>{{ data.assign_to }}</td>
              </tr>
            </tbody>
          </table>
          <pagination
            class="mt-4"
            :data="reportData"
            :limit="10"
            @pagination-change-page="generateReport"
          ></pagination>
        </div>

        <!-- REPORT - 3 -->
        <div class="mb-4 mt-4" v-if="isRep3">
          <h2 class="mb-5 mt-4">Report - 3</h2>

          <table id="rep3Table" class="table">
            <thead class="table-light">
              <tr>
                <th>Resource ID</th>
                <th>Center</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Status</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Mobile</th>
                <th>Building</th>
                <th>Department</th>
                <th>Category</th>
                <th>Assign To</th>
                <th>Location Name</th>
                <th>Location City</th>
                <th>Location State</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="noRecord">
                <td colspan="15" class="p-0">
                  <p class="font-size-16 text-center mt-2 mb-0">
                    Record Not Found!
                  </p>
                </td>
              </tr>

              <tr v-if="isLoading">
                <td colspan="15" class="text-center p-0">
                  <b-spinner
                    class="m-2"
                    variant="primary"
                    role="status"
                  ></b-spinner>
                </td>
              </tr>

              <tr v-else v-for="(data, index) in reportData.data" :key="index">
                <td>{{ data.resource_id }}</td>
                <td>{{ data.center }}</td>
                <td>{{ data.first_name }}</td>
                <td>{{ data.last_name }}</td>
                <td>{{ data.status }}</td>
                <td>{{ data.email }}</td>
                <td>{{ data.phone }}</td>
                <td>{{ data.mobile }}</td>
                <td>{{ data.building }}</td>
                <td>{{ data.department }}</td>
                <td>{{ data.category }}</td>
                <td>{{ data.assign_to }}</td>
                <td>{{ data.location_name }}</td>
                <td>{{ data.location_city }}</td>
                <td>{{ data.location_state }}</td>
              </tr>
            </tbody>
          </table>
          <pagination
            class="mt-4"
            :data="reportData"
            :limit="10"
            @pagination-change-page="generateReport"
          ></pagination>
        </div>

        <!-- REPORT - 4 -->
        <div class="mb-4 mt-4" v-if="isRep4">
          <h2 class="mb-5 mt-4">Report - 4</h2>

          <table id="rep4Table" class="table">
            <thead class="table-light">
              <tr>
                <th>Resource ID</th>
                <th>Center</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Shirt Size</th>
                <th>Category</th>
                <th>Building</th>
                <th>Department</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="noRecord">
                <td colspan="9" class="p-0">
                  <p class="font-size-16 text-center mt-2 mb-0">
                    Record Not Found!
                  </p>
                </td>
              </tr>

              <tr v-if="isLoading">
                <td colspan="9" class="text-center p-0">
                  <b-spinner
                    class="m-2"
                    variant="primary"
                    role="status"
                  ></b-spinner>
                </td>
              </tr>

              <tr v-else v-for="(data, index) in reportData.data" :key="index">
                <td>{{ data.resource_id }}</td>
                <td>{{ data.center }}</td>
                <td>{{ data.first_name }}</td>
                <td>{{ data.last_name }}</td>
                <td>{{ data.t_shirt }}</td>
                <td>{{ data.category }}</td>
                <td>{{ data.building }}</td>
                <td>{{ data.department }}</td>
                <td>{{ data.status }}</td>
              </tr>
            </tbody>
          </table>
          <pagination
            class="mt-4"
            :data="reportData"
            :limit="10"
            @pagination-change-page="generateReport"
          ></pagination>
        </div>

        <!-- REPORT - 5 -->
        <div class="mb-4 mt-4" v-if="isRep5">
          <h2 class="mb-5 mt-4">Report - 5</h2>

          <table id="rep5Table" class="table">
            <thead class="table-light">
              <tr>
                <th>Resource ID</th>
                <th>Center</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Category</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="noRecord">
                <td colspan="7" class="p-0">
                  <p class="font-size-16 text-center mt-2 mb-0">
                    Record Not Found!
                  </p>
                </td>
              </tr>

              <tr v-if="isLoading">
                <td colspan="7" class="text-center p-0">
                  <b-spinner
                    class="m-2"
                    variant="primary"
                    role="status"
                  ></b-spinner>
                </td>
              </tr>

              <tr v-else v-for="(data, index) in reportData.data" :key="index">
                <td>{{ data.resource_id }}</td>
                <td>{{ data.center }}</td>
                <td>{{ data.first_name }}</td>
                <td>{{ data.last_name }}</td>
                <td>{{ data.email }}</td>
                <td>{{ data.category }}</td>
                <td>{{ data.status }}</td>
              </tr>
            </tbody>
          </table>
          <pagination
            class="mt-4"
            :data="reportData"
            :limit="10"
            @pagination-change-page="generateReport"
          ></pagination>
        </div>

        <!-- REPORT - 6 (Social Security Report)-->
        <div class="mb-4 mt-4" v-if="isRep6">
          <h2 class="mb-5 mt-4">Social Security Report</h2>

          <table id="rep6Table" class="table">
            <thead class="table-light">
              <tr>
                <th>Resource ID</th>
                <th>Center</th>
                <th>Application Date</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Category</th>
                <th>Status</th>
                <th>SSN</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="noRecord">
                <td colspan="8" class="p-0">
                  <p class="font-size-16 text-center mt-2 mb-0">
                    Record Not Found!
                  </p>
                </td>
              </tr>

              <tr v-if="isLoading">
                <td colspan="8" class="text-center p-0">
                  <b-spinner
                    class="m-2"
                    variant="primary"
                    role="status"
                  ></b-spinner>
                </td>
              </tr>

              <tr v-else v-for="(data, index) in reportData.data" :key="index">
                <td>{{ data.resource_id }}</td>
                <td>{{ data.center }}</td>
                <td>{{ data.application_date }}</td>
                <td>{{ data.first_name }}</td>
                <td>{{ data.last_name }}</td>
                <td>{{ data.category }}</td>
                <td>{{ data.status }}</td>
                <td
                  v-if="
                    data.ssn != '' && data.ssn != 'REMOVED' && data.ssn != null
                  "
                >
                  {{ data.ssn.slice(0, 3) }}-#######
                </td>
                <td v-else>{{ data.ssn }}</td>
              </tr>
            </tbody>
          </table>
          <pagination
            class="mt-4"
            :data="reportData"
            :limit="10"
            @pagination-change-page="generateReport"
          ></pagination>
        </div>

        <!-- NewsLetter REPORT - 7 -->
        <div class="mb-4 mt-4" v-if="isRep7">
          <h2 class="mb-5 mt-4">NewsLetter Report</h2>

          <table id="rep6Table" class="table">
            <thead class="table-light">
              <tr>
                <th>Center</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email Addrfess</th>
                <th>Category</th>
                <th>Building</th>
                <th>Department</th>
                <th>Assign To</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="noRecord">
                <td colspan="9" class="p-0">
                  <p class="font-size-16 text-center mt-2 mb-0">
                    Record Not Found!
                  </p>
                </td>
              </tr>

              <tr v-if="isLoading">
                <td colspan="9" class="text-center p-0">
                  <b-spinner
                    class="m-2"
                    variant="primary"
                    role="status"
                  ></b-spinner>
                </td>
              </tr>

              <tr v-else v-for="(data, index) in reportData.data" :key="index">
                <td>{{ data.center }}</td>
                <td>{{ data.first_name }}</td>
                <td>{{ data.last_name }}</td>
                <td>{{ data.email }}</td>
                <td>{{ data.category }}</td>
                <td>{{ data.building }}</td>
                <td>{{ data.department }}</td>
                <td>{{ data.assign_to }}</td>
                <td>{{ data.status }}</td>
              </tr>
            </tbody>
          </table>
          <pagination
            class="mt-4"
            :data="reportData"
            :limit="10"
            @pagination-change-page="generateReport"
          ></pagination>
        </div>

        <!-- Mentor Hours Report - 8 -->
        <div class="mb-4 mt-4" v-if="isMentorHours">
          <div class="report_header d-flex justify-space-between mb-5">
            <h2 class="">MentorHours Report</h2>

            <form action="" class="d-flex justify-content-end">
              <div class="fil1 me-2">
                <b-form-select
                  class="form-select"
                  v-model="location"
                  :options="locations"
                  value-field="id"
                  text-field="name"
                  @change="getBuildings($event)"
                >
                  <option slot="first" :value="null">
                    -- All Locations --
                  </option>
                </b-form-select>
                <small>Locations</small>
              </div>
              <div class="fil1 me-2">
                <b-form-select
                  class="form-select"
                  v-model="building"
                  :options="buildings"
                  value-field="id"
                  text-field="name"
                >
                  <option slot="first" :value="null">
                    -- All Buildings --
                  </option>
                </b-form-select>
                <small>Buildings</small>
              </div>

              <div class="fil1 me-2">
                <input
                  type="date"
                  name="start_date"
                  v-model="start_date"
                  class="form-control me-2"
                />
                <small>Start Date</small>
              </div>
              <div class="fil2 me-2">
                <input
                  type="date"
                  name="end_date"
                  v-model="end_date"
                  class="form-control me-2"
                />
                <small>End Date</small>
              </div>
              <div class="fil3">
                <button
                  type="button"
                  @click="generateReport()"
                  class="btn btn-primary"
                >
                  Filter
                </button>
              </div>
            </form>
          </div>

          <table id="rep6Table" class="table">
            <thead class="table-light">
              <tr>
                <th>Center</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Category</th>
                <th>Building</th>
                <th>Assign To</th>
                <th>Hour Logged in Range</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="noRecord">
                <td colspan="7" class="p-0">
                  <p class="font-size-16 text-center mt-2 mb-0">
                    Record Not Found!
                  </p>
                </td>
              </tr>

              <tr v-if="isLoading">
                <td colspan="7" class="text-center p-0">
                  <b-spinner
                    class="m-2"
                    variant="primary"
                    role="status"
                  ></b-spinner>
                </td>
              </tr>

              <tr v-else v-for="(data, index) in reportData.data" :key="index">
                <td>{{ data.center }}</td>
                <td>{{ data.first_name }}</td>
                <td>{{ data.last_name }}</td>
                <td>{{ data.email }}</td>
                <td>{{ data.category }}</td>
                <td>{{ data.building }}</td>
                <td>{{ data.assign_to }}</td>
                <td>{{ data.hours }} hours : {{ data.minutes }}minutes</td>
              </tr>
            </tbody>
          </table>
          <pagination
            class="mt-4"
            :data="reportData"
            :limit="10"
            @pagination-change-page="generateReport"
          ></pagination>
          <div class="float-end">
            <h4>
              {{ this.total_hours }} hours : {{ this.total_minutes }} minutes
            </h4>
          </div>
        </div>

        <!-- Weekly Birthday Report - 9 -->
        <div class="mb-4 mt-4" v-if="isWeeklyBirthday">
          <div class="report_header d-flex justify-space-between mb-5">
            <h2 class="">Weekly Birthday Report</h2>
            <form action="" class="d-flex justify-content-end">
              <div class="fil1 me-2">
                <b-form-select
                  class="form-select"
                  v-model="location"
                  :options="locations"
                  value-field="id"
                  text-field="name"
                  @change="getBuildings($event)"
                >
                  <option slot="first" :value="null">
                    -- All Locations --
                  </option>
                </b-form-select>
                <small>Locations</small>
              </div>

              <div class="fil3">
                <button
                  type="button"
                  @click="generateReport()"
                  class="btn btn-primary"
                >
                  Filter
                </button>
              </div>
            </form>
          
          
          </div>

          <table id="rep6Table" class="table">
            <thead class="table-light">
              <tr>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Date of birth</th>
                <th>Location</th>
                <th>Category</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="noRecord">
                <td colspan="6" class="p-0">
                  <p class="font-size-16 text-center mt-2 mb-0">
                    Record Not Found!
                  </p>
                </td>
              </tr>

              <tr v-if="isLoading">
                <td colspan="6" class="text-center p-0">
                  <b-spinner
                    class="m-2"
                    variant="primary"
                    role="status"
                  ></b-spinner>
                </td>
              </tr>

              <tr v-else v-for="(data, index) in reportData.data" :key="index">
                <td>{{ data.first_name }}</td>
                <td>{{ data.last_name }}</td>
                <td>{{ data.email }}</td>
                <td>{{ dateFormatter(data.DOB) }}</td>
                <td>{{ data.location }}</td>
                <td>{{ data.user_type_id === 3 ? "Mentor" : "Voluteer" }}</td>
              </tr>
            </tbody>
          </table>
          <pagination
            class="mt-4"
            :data="reportData"
            :limit="10"
            @pagination-change-page="generateReport"
          ></pagination>
        </div>

        <!-- Mentor Roles Start Report - 10 -->
        <div class="mb-4 mt-4" v-if="isMentorRolesStart">
          <div class="report_header d-flex justify-space-between mb-5">
            <h2 class="">Monthly CCM Checkin</h2>
          </div>

          <table id="rep6Table" class="table">
            <thead class="table-light">
              <tr>
                <th>Center</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Category</th>
                <th>Building</th>
                <th>Assign To</th>
                <th>Start Date</th>
                <th>End Date</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="noRecord">
                <td colspan="10" class="p-0">
                  <p class="font-size-16 text-center mt-2 mb-0">
                    Record Not Found!
                  </p>
                </td>
              </tr>

              <tr v-if="isLoading">
                <td colspan="10" class="text-center p-0">
                  <b-spinner
                    class="m-2"
                    variant="primary"
                    role="status"
                  ></b-spinner>
                </td>
              </tr>

              <tr v-else v-for="(data, index) in reportData.data" :key="index">
                <td>{{ data.center }}</td>
                <td>{{ data.first_name }}</td>
                <td>{{ data.last_name }}</td>
                <td>{{ data.phone }}</td>
                <td>{{ data.email }}</td>
                <td>{{ data.category }}</td>
                <td>{{ data.building }}</td>
                <td>{{ data.assign_to }}</td>
                <td>{{ data.start_date }}</td>
                <td>{{ data.end_date }}</td>
              </tr>
            </tbody>
          </table>
          <pagination
            class="mt-4"
            :data="reportData"
            :limit="10"
            @pagination-change-page="generateReport"
          ></pagination>
        </div>
      </div>
    </div>
  </div>

  <!-- </Layout> -->
</template>

<style scoped>
.btn-primary {
  color: white;
  padding: 8px 20px;
  background: #556ee6;
}
.noReportSelected {
  text-align: right;
}
#csvlodaer {
  width: 100%;
  background: #fff;
  display: flex;
  justify-content: end;
}
#csvlodaer h2 {
  margin-top: 20px;
  max-width: 600px;
  font-size: 16px;
  color: #34c38f;
}
.report_header h2 {
  width: 50%;
  line-height: 1em;
  margin: 0px !important;
}
.report_header form {
  width: 50%;
}
</style>
